export default "__VITE_ASSET__CaQ_qNeB__"